var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.playersNumber)?_c('div',{staticClass:"game-content"},[_c('games-wrapper',{attrs:{"type":_vm.type,"exercise-id":_vm.exerciseId,"homework-id":_vm.homeworkId,"players-number":_vm.playersNumber,"play-again":_vm.playAgain}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }